import React from 'react';

const LastIcon = ({ className = '' }) => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`inline-block ${className}`}
  >
    <path
      d="M0.545898 0.583292L5.12923 6.99996L0.545898 13.4166H2.79173L7.37507 6.99996L2.79173 0.583292H0.545898ZM6.00007 0.583292L10.5834 6.99996L6.00007 13.4166H8.2459L12.8292 6.99996L8.2459 0.583292H6.00007Z"
      fill="currentColor"
    />
  </svg>
);

export default LastIcon;
